import { NgModule } from '@angular/core';
import { ListingPriceArrowComponent } from './listing-price-arrow.component';
import { CommonModule } from '@angular/common';
import { SharedPipesModule } from '../../pipes/shared-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    SharedPipesModule
  ],
  declarations: [
    ListingPriceArrowComponent
  ],
  exports: [
    ListingPriceArrowComponent
  ]
})
export class ListingPriceArrowModule { }
